import { Component, OnInit, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { IRatingDomainDto } from '../../interfaces/irating-domain';
import { IStudentEnrollmentInfo } from '../../interfaces/istudent-enrollment-info';
import { IRatingMeasureDto } from '../../interfaces/irating-measure';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@core/enums/permissions';
import { ITeacherSurvey, ITeacherSurveyRequest } from '../../interfaces/iteacher-survey';
import { isCoreDomain } from '@core/constants/domain.constants';
@Component({
    selector: 'drdp-rating-card',
    templateUrl: './rating-card.component.html',
    styleUrls: ['./rating-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RatingCardComponent implements OnInit {
  @Input() studentDomains: IRatingDomainDto[] = [];
  @Input() studentInfo?: IStudentEnrollmentInfo;
  @Input() isRatingDisabled = false;
  @Output() actionClicked = new EventEmitter();
  @Output() editClicked = new EventEmitter();
  @Output() viewClicked = new EventEmitter();
  private permissionService = inject(PermissionService);
  canCreateRating: boolean = this.permissionService.checkPermission(
    Permission.CreateRating
  );
  get isFieldStudy() { return (this.studentInfo?.isPilotEnrollment && this.studentInfo?.fieldStudyEnabledRatingPeriod) ?? false; }

  constructor() {}

  ngOnInit(): void {}

  isCoreDomain(domainCode: string): boolean {
    return isCoreDomain(domainCode);
  }

  selectRating(domain: IRatingDomainDto, measure: IRatingMeasureDto): void {
    if (!measure.ratingValue && !measure.measureConditionId && this.isFieldStudy) {
      const teacherSurveyReq: ITeacherSurveyRequest = {
        cardId: this.studentInfo?.carId,
        measureId: measure.id,
        isStructuredPrompt: measure.isStructuredPrompt
      };
      this.actionClicked.emit({ domain, measure, teacherSurveyReq });
    } else {
      this.actionClicked.emit({ domain, measure });
    }
  }

  editTeacherSurvey(measure: IRatingMeasureDto): void {
    const teacherSurveyReq: ITeacherSurveyRequest = {
      cardId: this.studentInfo?.carId,
      measureId: measure.id,
      isStructuredPrompt: measure.isStructuredPrompt
    };
    this.editClicked.emit({ teacherSurveyReq });
  }

  viewTeacherSurvey(measure: IRatingMeasureDto): void {
    const teacherSurveyReq: ITeacherSurveyRequest = {
      cardId: this.studentInfo?.carId,
      measureId: measure.id,
      isStructuredPrompt: measure.isStructuredPrompt
    };
    this.viewClicked.emit({ teacherSurveyReq });
  }
}
